import React, { useEffect, useState, useContext } from 'react';
import { Box, InputAdornment, InputLabel } from '@material-ui/core';
import BreadCrumbs from '../../../Core/Controls/Breadcrumb';
import { DefaultButton, SecondaryButton, TextBox, SelectBox, YesNoButton, ColorPicker } from '../../../Core/FormInput';
import { Typography, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { SketchPicker } from 'react-color';
import Grid from '@material-ui/core/Grid';
import FormLabel from '@material-ui/core/FormLabel';
import { useHistory } from 'react-router-dom';
import { getPortalSettings, addPortalSettings } from '../../../Core/Service/Settings';
import { getWorkflows } from '../../../Core/Service/workflow-service';
import CustomeEditor from '../../../Core/CkEditor';
import './style.scss';
import AppContext from '../../../App/AppContext';
import TabView from '../../../Core/Controls/Tabs';
import { FormControlLabel } from '@material-ui/core';
import { SecondaryCheckbox } from '../../../Core/FormInput';
import { useMemo } from 'react';
import { AppStorage } from '../../../Core/Service/storage-service';
import { getByWorkflowIdAndHeaderId } from '../../../Core/Service/returnReason-service';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Settings', path: '/', active: true }
];

const EwipModule = (props) => {
    const { state, handleClick, handleFieldChange, handleCkeditorstate, handleCheckbox } = props;
    return (
        <div style={{ padding: '20px 20px' }}>
            <Grid container spacing={2}>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Hide Work Accomplished and Failure Reasons?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.hideWorkAccomplishedAndFailureReasons}
                        name="hideWorkAccomplishedAndFailureReasons"
                        onYesClick={() => handleClick('hideWorkAccomplishedAndFailureReasons', true)}
                        onNoClick={() => handleClick('hideWorkAccomplishedAndFailureReasons', false)}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Show workflow steps as buttons?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.workflowStepOptionsAsButtonGroup}
                        name="workflowStepOptionsAsButtonGroup"
                        onYesClick={() => handleClick('workflowStepOptionsAsButtonGroup', true)}
                        onNoClick={() => handleClick('workflowStepOptionsAsButtonGroup', false)}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Display Part Stock Status?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.portalSettingDisplayPartStockStatus}
                        name="portalSettingDisplayPartStockStatus"
                        onYesClick={() => handleClick('portalSettingDisplayPartStockStatus', true)}
                        onNoClick={() => handleClick('portalSettingDisplayPartStockStatus', false)}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} container>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel shrink>Workflow - unassigned technician job</FormLabel>
                    </Grid>
                    <SelectBox
                        onChange={handleFieldChange}
                        value={state.portalSettingUnassignedTechnicianJobWorkflowID}
                        name="portalSettingUnassignedTechnicianJobWorkflowID"
                        List={state.workFlowList || []}
                    />
                </Grid>

                <Grid container item xs={12} sm={6} lg={3}>
                    <Grid xs={12} sm={6} md={7} item style={{ paddingRight: '15px' }}>
                        <FormLabel> Grid Refresh Time (seconds)</FormLabel>
                        <TextBox type="number" value={state.portalSettingGridRefreshTime} onChange={handleFieldChange} name="portalSettingGridRefreshTime" />
                    </Grid>
                    <Grid xs={12} sm={6} md={5} item>
                        <FormLabel> Tech Writeup Height</FormLabel>
                        <TextBox
                            type="number"
                            value={state.portalSettingTechnWriteupHeight}
                            onChange={handleFieldChange}
                            name="portalSettingTechnWriteupHeight"
                        />
                    </Grid>
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Show Reg In Customer Rating Box?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.showRegNumberInCustomerRatingBox}
                        name="showRegNumberInCustomerRatingBox"
                        onYesClick={() => handleClick('showRegNumberInCustomerRatingBox', true)}
                        onNoClick={() => handleClick('showRegNumberInCustomerRatingBox', false)}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Save New Document Version?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.portalSettingSaveNewDoc}
                        name="portalSettingSaveNewDoc"
                        onYesClick={() => handleClick('portalSettingSaveNewDoc', true)}
                        onNoClick={() => handleClick('portalSettingSaveNewDoc', false)}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Show Tech Write Up Save Button?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.portalSettingsShowTechWriteUpSaveBtn}
                        name="portalSettingsShowTechWriteUpSaveBtn"
                        onYesClick={() => handleClick('portalSettingsShowTechWriteUpSaveBtn', true)}
                        onNoClick={() => handleClick('portalSettingsShowTechWriteUpSaveBtn', false)}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Show Tech Write Up Submit Button?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.portalSettingDisplaySubmitbutton}
                        name="portalSettingDisplaySubmitbutton"
                        onYesClick={() => handleClick('portalSettingDisplaySubmitbutton', true)}
                        onNoClick={() => handleClick('portalSettingDisplaySubmitbutton', false)}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Disallow technician signature on save button?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.portalSettingDisallowTechnicianSignatureOnSaveButton}
                        name="portalSettingDisallowTechnicianSignatureOnSaveButton"
                        onYesClick={() => handleClick('portalSettingDisallowTechnicianSignatureOnSaveButton', true)}
                        onNoClick={() => handleClick('portalSettingDisallowTechnicianSignatureOnSaveButton', false)}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Display Assigned Workflows?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.portalSettingDisplayAssignedWorkflows}
                        name="portalSettingDisplayAssignedWorkflows"
                        onYesClick={() => handleClick('portalSettingDisplayAssignedWorkflows', true)}
                        onNoClick={() => handleClick('portalSettingDisplayAssignedWorkflows', false)}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} container>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel shrink>NightShift Workflow</FormLabel>
                    </Grid>
                    <SelectBox
                        onChange={handleFieldChange}
                        value={state.portalSettingNightShiftWorkflowID}
                        name="portalSettingNightShiftWorkflowID"
                        List={state.workFlowList || []}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} container>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel shrink>Return Reason</FormLabel>
                    </Grid>
                    <SelectBox
                        onChange={handleFieldChange}
                        value={state.portalSettingReturnReasonID}
                        name="portalSettingReturnReasonID"
                        List={state.returnReasonList || []}
                    />
                </Grid>

                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Writeups In Upper Case?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.portalSettingWriteupsInUpperCase}
                        name="portalSettingWriteupsInUpperCase"
                        onYesClick={() => handleClick('portalSettingWriteupsInUpperCase', true)}
                        onNoClick={() => handleClick('portalSettingWriteupsInUpperCase', false)}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} container>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel shrink>Workflow - Notification</FormLabel>
                    </Grid>
                    <SelectBox
                        onChange={handleFieldChange}
                        value={state.portalSettingWorkflowNotification}
                        name="portalSettingWorkflowNotification"
                        List={[
                            { name: 'Off', id: '0' },
                            { name: 'Always On', id: '1' },
                            { name: 'User Preference', id: '2' }
                        ]}
                    />
                </Grid>

                {/* <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Can Hide Document Creation?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.canHideDocumentCreation}
                        name="canHideDocumentCreation"
                        onYesClick={() => handleClick('canHideDocumentCreation', true)}
                        onNoClick={() => handleClick('canHideDocumentCreation', false)}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Can Delete Part Requests?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.canDeletePartRequests}
                        name="canDeletePartRequests"
                        onYesClick={() => handleClick('canDeletePartRequests', true)}
                        onNoClick={() => handleClick('canDeletePartRequests', false)}
                    />
                </Grid> */}
                <Grid xs={12} container item>
                    <Grid item xs={12}>
                        <InputLabel style={{ marginBottom: 7 }}>FM/Warranty Warning message</InputLabel>
                        <TextBox
                            inputLabel="FM/Warranty Warning message"
                            placeholder=""
                            value={state.portalSettingFMWarrantyWarningmsg}
                            onChange={handleFieldChange}
                            name="portalSettingFMWarrantyWarningmsg"
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                    <Typography variant="body2" color="secondary">
                        Diagnostic Charges
                    </Typography>
                    <hr />
                    <CustomeEditor data={state.Diag} onChange={handleCkeditorstate('Diag')} placeholder="Add description here" name="Diag" />
                </Grid>
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                    <Typography variant="body2" color="secondary">
                        Quality Control
                    </Typography>
                    <hr />
                    <CustomeEditor data={state.Qual} onChange={handleCkeditorstate('Qual')} placeholder="Add description here" name="Qual" />
                </Grid>
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                    <Typography variant="body2" color="secondary">
                        Terms Of Service
                    </Typography>
                    <hr />
                    <CustomeEditor
                        data={state.termsOfService}
                        onChange={handleCkeditorstate('termsOfService')}
                        placeholder="Add description here"
                        name="termsOfService"
                    />
                </Grid>
            </Grid>
            <Grid container item xs={12} sm={12}>
                <Grid item xs={12} md={12} lg={12} style={{ top: 0, textAlign: 'left', paddingTop: '15px' }}>
                    <Typography variant="body2" color="secondary">
                        User Grid Columns
                    </Typography>
                    <hr />
                </Grid>
                <Grid container style={{ textAlign: 'left' }} spacing={2}>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Action</FormLabel>
                        <TextBox
                            inputLabel="Action"
                            placeholder="Action"
                            value={state.portalSettingGridActionLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridActionLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>WIP No</FormLabel>
                        <TextBox
                            inputLabel="WIPNo"
                            placeholder="WIP No"
                            value={state.portalSettingGridWIPNoLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridWIPNoLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Vehicle Reg</FormLabel>
                        <TextBox
                            inputLabel="VehicleReg"
                            placeholder="Vehicle Reg"
                            value={state.portalSettingGridVehicleRegLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridVehicleRegLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Model</FormLabel>
                        <TextBox
                            inputLabel="Model"
                            placeholder="Model"
                            value={state.portalSettingGridModelLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridModelLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Customer Name</FormLabel>
                        <TextBox
                            inputLabel="CustomerName"
                            placeholder="Customer Name"
                            value={state.portalSettingGridCustomerNameLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridCustomerNameLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Date Due In</FormLabel>
                        <TextBox
                            inputLabel="DateDueIn"
                            placeholder="Date Due In"
                            value={state.portalSettingGridDateDueInLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridDateDueInLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Date Due Out</FormLabel>
                        <TextBox
                            inputLabel="DateDueOut"
                            placeholder="Date Due Out"
                            value={state.portalSettingGridDateDueOutLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridDateDueOutLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Return Reason</FormLabel>
                        <TextBox
                            inputLabel="ReturnReason"
                            placeholder="Return Reason"
                            value={state.portalSettingGridReturnReasonLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridReturnReasonLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Branch</FormLabel>
                        <TextBox
                            inputLabel="Branch"
                            placeholder="Branch"
                            value={state.portalSettingGridBranchLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridBranchLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Franchise</FormLabel>
                        <TextBox
                            inputLabel="Franchise"
                            placeholder="Franchise"
                            value={state.portalSettingGridFranchiseLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridFranchiseLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Job Description</FormLabel>
                        <TextBox
                            inputLabel="JobDescription"
                            placeholder="Job Description"
                            value={state.portalSettingGridJobDescriptionLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridJobDescriptionLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Account</FormLabel>
                        <TextBox
                            inputLabel="Account"
                            placeholder="Account"
                            value={state.portalSettingGridAccountLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridAccountLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Created By</FormLabel>
                        <TextBox
                            inputLabel="CreatedBy"
                            placeholder="Created By"
                            value={state.portalSettingGridCreatedByLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridCreatedByLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Assigned Date</FormLabel>
                        <TextBox
                            inputLabel="AssignedDate"
                            placeholder="Assigned Date"
                            value={state.portalSettingGridAssignedDateLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridAssignedDateLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Time Taken</FormLabel>
                        <TextBox
                            inputLabel="TimeTaken"
                            placeholder="Time Taken"
                            value={state.portalSettingGridTimeTakenLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridTimeTakenLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Status</FormLabel>
                        <TextBox
                            inputLabel="Status"
                            placeholder="Status"
                            value={state.portalSettingGridStatusLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridStatusLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Assigned Days</FormLabel>
                        <TextBox
                            inputLabel="AssignedDays"
                            placeholder="Assigned Days"
                            value={state.portalSettingGridAssignedDaysLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridAssignedDaysLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Chassis Number</FormLabel>
                        <TextBox
                            inputLabel="ChassisNumber"
                            placeholder="Chassis Number"
                            value={state.portalSettingGridChassisNumberLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridChassisNumberLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Owning Operator</FormLabel>
                        <TextBox
                            inputLabel="OwningOperator"
                            placeholder="Owning Operator"
                            value={state.portalSettingGridOwningOperatorLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridOwningOperatorLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Assigned User</FormLabel>
                        <TextBox
                            inputLabel="AssignedUser"
                            placeholder="Assigned User"
                            value={state.portalSettingGridJobAssignedUserLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridJobAssignedUserLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Customer Waiting</FormLabel>
                        <TextBox
                            inputLabel="CustomerWaiting"
                            placeholder="Customer Waiting"
                            value={state.portalSettingGridCustomerWaitingLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridCustomerWaitingLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Loan Vehicle</FormLabel>
                        <TextBox
                            inputLabel="LoanVehicle"
                            placeholder="Loan Vehicle"
                            value={state.portalSettingGridCourtesyCarReqLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridCourtesyCarReqLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>WIP Age</FormLabel>
                        <TextBox
                            inputLabel="LoanVehicle"
                            placeholder="Loan Vehicle"
                            value={state.portalSettingGridWIPAgeLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridWIPAgeLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <InputLabel>FM Or Warranty Label</InputLabel>
                        <TextBox
                            placeholder="FM Or Warranty Label"
                            value={state.portalSettingGridIsFMOrWarrantyLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridIsFMOrWarrantyLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <InputLabel>Breakdown Label</InputLabel>
                        <TextBox
                            placeholder="Breakdown Label"
                            value={state.portalSettingGridIsBreakdownLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridIsBreakdownLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <InputLabel>Night Shift Label</InputLabel>
                        <TextBox
                            placeholder="Night Shift Label"
                            value={state.portalSettingGridIsNightShiftLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridIsNightShiftLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <InputLabel>Is High Priority Label</InputLabel>
                        <TextBox
                            placeholder="Is High Priority Label"
                            value={state.portalSettingGridIsHighPriorityLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridIsHighPriorityLabel"
                        />
                    </Grid>
                    {/* <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Job Assigned User</FormLabel>
                        <TextBox
                            inputLabel="LoanVehicle"
                            placeholder="Loan Vehicle"
                            value={state.portalSettingGridJobAssignedUserLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridJobAssignedUserLabel"
                        />
                    </Grid> */}
                </Grid>
            </Grid>
            <Grid container spacing={2} item xs={12} sm={12} style={{ textAlign: 'left' }}>
                <Grid item xs={12} md={12} lg={12} style={{ top: 0, textAlign: 'left', paddingTop: '15px' }}>
                    <Typography variant="body2" color="secondary">
                        Workflow Button Visibility
                    </Typography>
                    <hr />
                </Grid>
                <Grid item xs={12} md={12} lg={12} style={{ top: 0, textAlign: 'left', marginTop: '-15px' }}>
                    <Typography variant="body2" color="primary" style={{ fontWeight: 'bold' }}>
                        Customer
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={<SecondaryCheckbox checked={state.canCustomerViewNotesButton} onChange={handleCheckbox} name="canCustomerViewNotesButton" />}
                        label="Show Notes Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={
                            <SecondaryCheckbox checked={state.canCustomerViewHistoryButton} onChange={handleCheckbox} name="canCustomerViewHistoryButton" />
                        }
                        label="Show History Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={<SecondaryCheckbox checked={state.canCustomerViewSaveButton} onChange={handleCheckbox} name="canCustomerViewSaveButton" />}
                        label="Show Save Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={
                            <SecondaryCheckbox
                                checked={state.canCustomerViewSaveAndCompleteButton}
                                onChange={handleCheckbox}
                                name="canCustomerViewSaveAndCompleteButton"
                            />
                        }
                        label="Show Save & Complete Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={<SecondaryCheckbox checked={state.canCustomerViewReturnButton} onChange={handleCheckbox} name="canCustomerViewReturnButton" />}
                        label="Show Return Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={
                            <SecondaryCheckbox
                                checked={state.canCustomerViewReturnReasonHistoryButton}
                                onChange={handleCheckbox}
                                name="canCustomerViewReturnReasonHistoryButton"
                            />
                        }
                        label="Show Return History Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={
                            <SecondaryCheckbox
                                checked={state.canCustomerViewAllDocumentsButton}
                                onChange={handleCheckbox}
                                name="canCustomerViewAllDocumentsButton"
                            />
                        }
                        label="Show All Documents Button?"
                    />
                </Grid>

                <Grid item xs={12} md={12} lg={12} style={{ top: 0, textAlign: 'left' }}>
                    <Typography variant="body2" color="primary" style={{ fontWeight: 'bold' }}>
                        Auditor
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={<SecondaryCheckbox checked={state.canAuditorViewNotesButton} onChange={handleCheckbox} name="canAuditorViewNotesButton" />}
                        label="Show Notes Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={<SecondaryCheckbox checked={state.canAuditorViewHistoryButton} onChange={handleCheckbox} name="canAuditorViewHistoryButton" />}
                        label="Show History Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={<SecondaryCheckbox checked={state.canAuditorViewSaveButton} onChange={handleCheckbox} name="canAuditorViewSaveButton" />}
                        label="Show Save Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={
                            <SecondaryCheckbox
                                checked={state.canAuditorViewSaveAndCompleteButton}
                                onChange={handleCheckbox}
                                name="canAuditorViewSaveAndCompleteButton"
                            />
                        }
                        label="Show Save & Complete Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={<SecondaryCheckbox checked={state.canAuditorViewReturnButton} onChange={handleCheckbox} name="canAuditorViewReturnButton" />}
                        label="Show Return Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={
                            <SecondaryCheckbox
                                checked={state.canAuditorViewReturnReasonHistoryButton}
                                onChange={handleCheckbox}
                                name="canAuditorViewReturnReasonHistoryButton"
                            />
                        }
                        label="Show Return History Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={
                            <SecondaryCheckbox
                                checked={state.canAuditorViewAllDocumentsButton}
                                onChange={handleCheckbox}
                                name="canAuditorViewAllDocumentsButton"
                            />
                        }
                        label="Show All Documents Button?"
                    />
                </Grid>
            </Grid>
        </div>
    );
};

const CommunicatorModule = (props) => {
    const { state, OnColorSelect } = props;
    return (
        <div style={{ padding: '20px 20px' }}>
            <Grid container spacing={2}>
                <Grid item container spacing={4} xs={12} md={3} sm={6}>
                    <Grid item xs={12} sm={12}>
                        <FormLabel component="legend">
                            <b>High Priority Job Colour</b>
                        </FormLabel>
                    </Grid>
                    <Grid item xs={12} md={3} sm={6}>
                        <SketchPicker
                            color={state.portalHighPriorityJobColour}
                            onChange={(updatedColor) => OnColorSelect(updatedColor, 'portalHighPriorityJobColour')}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

const Settings = (props) => {
    const [state, setState] = useState({
        Title: '',
        CallUs: '',
        OpeningTimes: '',
        EmailUs: '',
        Diag: '',
        termsOfService: '',
        Qual: '',
        HeaderTextColorCode: '',
        HeaderBackgroundColorCode: '',
        MenubarTextColorCode: '',
        MenubarBackgroundColorCode: '',
        portalSettingTechnicianDeclaration: null,
        portalHighPriorityJobColour: '',
        productLogo: '',
        labelLogo: '',
        bannerLogo: '',
        navigationMenuActive: '',
        bannerImage: '',
        Id: '',
        workflowStepOptionsAsButtonGroup: false,
        hideWorkAccomplishedAndFailureReasons: false,
        portalSettingUnassignedTechnicianJobWorkflowID: null,
        isReload: new Date(),
        portalSettingSaveNewDoc: true,
        // portalSettingeWIPEnabled: false,
        // portalSettingReportingEnabled: false,
        portalSettingsShowTechWriteUpSaveBtn: false,
        portalSettingDisplaySubmitbutton: false,
        portalSettingDisallowTechnicianSignatureOnSaveButton: false,
        canCustomerViewNotesButton: false,
        canCustomerViewHistoryButton: false,
        canCustomerViewSaveButton: false,
        canCustomerViewSaveAndCompleteButton: false,
        canCustomerViewReturnButton: false,
        canCustomerViewReturnReasonHistoryButton: false,
        canCustomerViewAllDocumentsButton: false,
        canAuditorViewNotesButton: false,
        canAuditorViewHistoryButton: false,
        canAuditorViewSaveButton: false,
        canAuditorViewSaveAndCompleteButton: false,
        canAuditorViewReturnButton: false,
        canAuditorViewReturnReasonHistoryButton: false,
        canAuditorViewAllDocumentsButton: false,
        PortalSettingsPassowrdMinimumLength: 0,
        portalSettingDisplayAssignedWorkflows: false,
        portalSettingNightShiftWorkflowID: '',
        portalSettingReturnReasonID: '',
        portalSettingWorkflowNotification: '',
        portalSettingGridIsFMOrWarrantyLabel: '',
        portalSettingGridIsBreakdownLabel: '',
        portalSettingGridIsNightShiftLabel: '',
        portalSettingGridIsNightShiftLabel: '',
        portalSettingGridIsHighPriorityLabel: '',
        portalSettingWriteupsInUpperCase: false,
        portalSettingWriteupsInUpperCase: false,
        portalSettingWriteupsInUpperCase: false,
        canHideDocumentCreation: false,
        canDeletePartRequests: false,
        portalSettingsRecallJobTextColor: '',
        portalSettingsRecallJobBgColor: '',
        portalSettingsRepairTextColor: '',
        portalSettingsRepairBgColor: '',
        portalSettingsMOTTextColor: '',
        portalSettingsMOTBgColor: '',
        portalSettingsInspectionTextColor: '',
        portalSettingsInspectionBgColor: '',
        portalSettingsCustomerWaitingTextColor: '',
        portalSettingsCustomerWaitingBgColor: '',
        portalSettingsCollectionDeliverTextColor: '',
        portalSettingsCollectionDeliverBgColor: '',
        portalSettingsServiceTextColor: '',
        portalSettingsServiceBgColor: '',
        portalSettingsNightShiftTextColor: '',
        portalSettingsNightShiftBgColor: '',
        portalSettingsTachoTextColor: '',
        portalSettingsTachoBgColor: '',
        portalSettingsLoanVehicleBgColor: '',
        portalSettingsLoanVehicleTextColor: '',
        portalSettingsRecallJobText: '',
        portalSettingsRepairText: '',
        portalSettingsMOTText: '',
        portalSettingsInspectionText: '',
        portalSettingsCustomerWaitingText: '',
        portalSettingsCollectionDeliverText: '',
        portalSettingsServiceText: '',
        portalSettingsNightShiftText: '',
        portalSettingsTachoText: '',
        portalSettingsLoanVehicleText: '',
        portalSettingsIsHolidayBgColor: '',
        portalSettingsIsHolidayColor: '',
        portalSettingsRecallIsTcardColor: false,
        portalSettingsRepairIsTcardColor: false,
        portalSettingsMOTIsTcardColor: false,
        portalSettingsInspectionIsTcardColor: false,
        portalSettingsCustomerWaitingIsTcardColor: false,
        portalSettingsCollectionDeliverIsTcardColor: false,
        portalSettingsServiceIsTcardColor: false,
        portalSettingsNightShiftIsTcardColor: false,
        portalSettingsTachoIsTcardColor: false,
        portalSettingsLoanVehicleIsTcardColor: false
    });
    const { showToast, portalSettings } = useContext(AppContext);

    const history = useHistory();

    const OnColorSelect = (updatedColor, name) => {
        setState((state) => ({
            ...state,
            [name]: updatedColor.hex
        }));
    };
    const pullSettingsAndUpdateState = async () => {
        let res = await getPortalSettings();
        const data = res?.data?.details[0];
        if (res.success) {
            setState((st) => ({
                ...st,
                Id: data.portalSettingId,
                Title: data.portalSettingTitle,
                CallUs: data.portalSettingCallUs,
                OpeningTimes: data.portalSettingOpeningTime,
                EmailUs: data.portalSettingEmailUs,
                Diag: data.portalSettingDiagnosticCharges || '',
                termsOfService: data.portalSettingsTermsOfService || '',
                Qual: data.portalSettingQCMessage || '',
                HeaderTextColorCode: data.portalHeaderTextColour,
                HeaderBackgroundColorCode: data.portalHeaderBackgroundColour,
                MenubarTextColorCode: data.portalMenuBarTextColour,
                MenubarBackgroundColorCode: data.portalMenuBarBackgroundColour,

                portalSettingsRecallJobTextColor: data.portalSettingsRecallJobTextColor,
                portalSettingsRecallJobBgColor: data.portalSettingsRecallJobBgColor,
                portalSettingsRepairTextColor: data.portalSettingsRepairTextColor,
                portalSettingsRepairBgColor: data.portalSettingsRepairBgColor,
                portalSettingsMOTTextColor: data.portalSettingsMOTTextColor,
                portalSettingsMOTBgColor: data.portalSettingsMOTBgColor,
                portalSettingsInspectionTextColor: data.portalSettingsInspectionTextColor,
                portalSettingsInspectionBgColor: data.portalSettingsInspectionBgColor,
                portalSettingsCustomerWaitingTextColor: data.portalSettingsCustomerWaitingTextColor,
                portalSettingsCustomerWaitingBgColor: data.portalSettingsCustomerWaitingBgColor,
                portalSettingsCollectionDeliverTextColor: data.portalSettingsCollectionDeliverTextColor,
                portalSettingsCollectionDeliverBgColor: data.portalSettingsCollectionDeliverBgColor,
                portalSettingsServiceTextColor: data.portalSettingsServiceTextColor,
                portalSettingsServiceBgColor: data.portalSettingsServiceBgColor,
                portalSettingsNightShiftTextColor: data.portalSettingsNightShiftTextColor,
                portalSettingsNightShiftBgColor: data.portalSettingsNightShiftBgColor,
                portalSettingsTachoTextColor: data.portalSettingsTachoTextColor,
                portalSettingsTachoBgColor: data.portalSettingsTachoBgColor,
                portalSettingsLoanVehicleBgColor: data.portalSettingsLoanVehicleBgColor,
                portalSettingsLoanVehicleTextColor: data.portalSettingsLoanVehicleTextColor,
                portalSettingsRecallJobText: data.portalSettingsRecallJobText,
                portalSettingsRepairText: data.portalSettingsRepairText,
                portalSettingsMOTText: data.portalSettingsMOTText,
                portalSettingsInspectionText: data.portalSettingsInspectionText,
                portalSettingsCustomerWaitingText: data.portalSettingsCustomerWaitingText,
                portalSettingsCollectionDeliverText: data.portalSettingsCollectionDeliverText,
                portalSettingsServiceText: data.portalSettingsServiceText,
                portalSettingsNightShiftText: data.portalSettingsNightShiftText,
                portalSettingsTachoText: data.portalSettingsTachoText,
                portalSettingsLoanVehicleText: data.portalSettingsLoanVehicleText,
                portalSettingsIsHolidayBgColor: data.portalSettingsIsHolidayBgColor,
                portalSettingsIsHolidayColor: data.portalSettingsIsHolidayColor,

                navigationMenuActive: data.portalSettingDisplayTopNavCounters,
                workflowStepOptionsAsButtonGroup: data.workflowStepOptionsAsButtonGroup,
                hideWorkAccomplishedAndFailureReasons: data.hideWorkAccomplishedAndFailureReasons || false,
                portalSettingSaveNewDoc: data.portalSettingSaveNewDoc,
                productLogo: data.portalSettingMainLogo,
                bannerLogo: data.portalSettingBanner,
                labelLogo: data.portalSettingAdditionalLogo,
                bannerImage: data.portalSettingBannerImage,
                portalSettingTechnicianDeclaration: data.portalSettingTechnicianDeclaration,
                portalSettingGridRefreshTime: data.portalSettingGridRefreshTime,
                portalSettingTechnWriteupHeight: data.portalSettingTechnWriteupHeight || 4,
                portalSettingDisplayPartStockStatus: data.portalSettingDisplayPartStockStatus,

                portalSettingGridActionLabel: data.portalSettingGridActionLabel,
                portalSettingGridWIPNoLabel: data.portalSettingGridWIPNoLabel,
                portalSettingGridVehicleRegLabel: data.portalSettingGridVehicleRegLabel,
                portalSettingGridModelLabel: data.portalSettingGridModelLabel,
                portalSettingGridCustomerNameLabel: data.portalSettingGridCustomerNameLabel,
                portalSettingGridDateDueInLabel: data.portalSettingGridDateDueInLabel,
                portalSettingGridDateDueOutLabel: data.portalSettingGridDateDueOutLabel,
                portalSettingGridReturnReasonLabel: data.portalSettingGridReturnReasonLabel,
                portalSettingGridBranchLabel: data.portalSettingGridBranchLabel,
                portalSettingGridFranchiseLabel: data.portalSettingGridFranchiseLabel,
                portalSettingGridJobDescriptionLabel: data.portalSettingGridJobDescriptionLabel,
                portalSettingGridAccountLabel: data.portalSettingGridAccountLabel,
                portalSettingGridCreatedByLabel: data.portalSettingGridCreatedByLabel,
                portalSettingGridAssignedDateLabel: data.portalSettingGridAssignedDateLabel,
                portalSettingGridTimeTakenLabel: data.portalSettingGridTimeTakenLabel,
                portalSettingGridStatusLabel: data.portalSettingGridStatusLabel,
                portalSettingGridAssignedDaysLabel: data.portalSettingGridAssignedDaysLabel,
                portalSettingGridChassisNumberLabel: data.portalSettingGridChassisNumberLabel,
                portalSettingGridOwningOperatorLabel: data.portalSettingGridOwningOperatorLabel,
                portalSettingGridWIPAgeLabel: data.portalSettingGridWIPAgeLabel,
                portalSettingGridIsFMOrWarrantyLabel: data.portalSettingGridIsFMOrWarrantyLabel,
                portalSettingGridIsBreakdownLabel: data.portalSettingGridIsBreakdownLabel,
                portalSettingGridIsNightShiftLabel: data.portalSettingGridIsNightShiftLabel,
                // portalSettingGridJobAssignedUserLabel: data.portalSettingGridJobAssignedUserLabel,
                portalSettingUnassignedTechnicianJobWorkflowID: data.portalSettingUnassignedTechnicianJobWorkflowID,
                portalSettingGridCustomerWaitingLabel: data.portalSettingGridCustomerWaitingLabel,
                portalSettingGridCourtesyCarReqLabel: data.portalSettingGridCourtesyCarReqLabel,
                portalSettingGridJobAssignedUserLabel: data.portalSettingGridJobAssignedUserLabel,
                portalSettingTimeOut: data.portalSettingTimeOut,
                portalSettingPasswordExpiryDuration: data.portalSettingPasswordExpiryDuration,
                portalSettingsPassowrdMinimumLength: data.portalSettingsPassowrdMinimumLength,
                portalSettingFMWarrantyWarningmsg: data.portalSettingFMWarrantyWarningmsg,
                // portalSettingReportingEnabled: data.portalSettingReportingEnabled
                portalSettingSpecialEquipmentEnabled: data.portalSettingSpecialEquipmentEnabled,
                showRegNumberInCustomerRatingBox: data.showRegNumberInCustomerRatingBox,
                portalHighPriorityJobColour: data.portalHighPriorityJobColour || '',
                canCustomerViewNotesButton: data.canCustomerViewNotesButton,
                canCustomerViewHistoryButton: data.canCustomerViewHistoryButton,
                canCustomerViewSaveButton: data.canCustomerViewSaveButton,
                canCustomerViewSaveAndCompleteButton: data.canCustomerViewSaveAndCompleteButton,
                canCustomerViewReturnButton: data.canCustomerViewReturnButton,
                canCustomerViewReturnReasonHistoryButton: data.canCustomerViewReturnReasonHistoryButton,
                canCustomerViewAllDocumentsButton: data.canCustomerViewAllDocumentsButton,
                canAuditorViewNotesButton: data.canAuditorViewNotesButton,
                canAuditorViewHistoryButton: data.canAuditorViewHistoryButton,
                canAuditorViewSaveButton: data.canAuditorViewSaveButton,
                canAuditorViewSaveAndCompleteButton: data.canAuditorViewSaveAndCompleteButton,
                canAuditorViewReturnButton: data.canAuditorViewReturnButton,
                canAuditorViewReturnReasonHistoryButton: data.canAuditorViewReturnReasonHistoryButton,
                canAuditorViewAllDocumentsButton: data.canAuditorViewAllDocumentsButton,
                isReload: new Date(),
                portalSettingsShowTechWriteUpSaveBtn: data.portalSettingsShowTechWriteUpSaveBtn,
                portalSettingDisplaySubmitbutton: data.portalSettingDisplaySubmitbutton,
                portalSettingDisallowTechnicianSignatureOnSaveButton: data.portalSettingDisallowTechnicianSignatureOnSaveButton,
                portalSettingDisplayAssignedWorkflows: data.portalSettingDisplayAssignedWorkflows,
                portalSettingNightShiftWorkflowID: data.portalSettingNightShiftWorkflowID,
                portalSettingReturnReasonID: data.portalSettingReturnReasonID,
                portalSettingWorkflowNotification: data.portalSettingWorkflowNotification,
                portalSettingGridIsFMOrWarrantyLabel: data.portalSettingGridIsFMOrWarrantyLabel,
                portalSettingGridIsBreakdownLabel: data.portalSettingGridIsBreakdownLabel,
                portalSettingGridIsNightShiftLabel: data.portalSettingGridIsNightShiftLabel,
                portalSettingGridIsHighPriorityLabel: data.portalSettingGridIsHighPriorityLabel,
                portalSettingWriteupsInUpperCase: data.portalSettingWriteupsInUpperCase,
                canHideDocumentCreation: data.canHideDocumentCreation,
                canDeletePartRequests: data.canDeletePartRequests,
                portalSettingsRecallIsTcardColor: data.portalSettingsRecallIsTcardColor,
                portalSettingsRepairIsTcardColor: data.portalSettingsRepairIsTcardColor,
                portalSettingsMOTIsTcardColor: data.portalSettingsMOTIsTcardColor,
                portalSettingsInspectionIsTcardColor: data.portalSettingsInspectionIsTcardColor,
                portalSettingsCustomerWaitingIsTcardColor: data.portalSettingsCustomerWaitingIsTcardColor,
                portalSettingsCollectionDeliverIsTcardColor: data.portalSettingsCollectionDeliverIsTcardColor,
                portalSettingsServiceIsTcardColor: data.portalSettingsServiceIsTcardColor,
                portalSettingsNightShiftIsTcardColor: data.portalSettingsNightShiftIsTcardColor,
                portalSettingsTachoIsTcardColor: data.portalSettingsTachoIsTcardColor,
                portalSettingsLoanVehicleIsTcardColor: data.portalSettingsLoanVehicleIsTcardColor,
                vehicleStatusNotArrivedTxtColor: data?.vehicleStatusNotArrivedTxtColor || '',
                vehicleStatusOnSiteTxtColor: data?.vehicleStatusOnSiteTxtColor || '',
                vehicleStatusOffsiteTxtColor: data?.vehicleStatusOffsiteTxtColor || '',
                vehicleStatusNotArrivedBgColor: data?.vehicleStatusNotArrivedBgColor || '',
                vehicleStatusOnSiteBgColor: data?.vehicleStatusOnSiteBgColor || '',
                vehicleStatusOffsiteBgColor: data?.vehicleStatusOffsiteBgColor || ''
            }));
        }
        if (!res.success) {
            console.log(res.message);
        }
    };
    let handleImage = (bannerLogo) => (event) => {
        let reader = new FileReader();
        reader.onload = (e) => {
            const { result } = e.target;
            setState((st) => ({
                ...st,
                [bannerLogo]: result
            }));
        };
        reader.readAsDataURL(event.target.files[0]);
    };

    const clearImage = (name) => (e) => {
        setState((st) => ({ ...st, [name]: null }));
    };

    const modelgridStyle = {
        formatterImageContainer: { width: '100%', textAlign: 'left' },
        //  formatterImage: { width: '40%', maxHeight: 60, backgroundSize: 'cover' },
        formatterImage: { width: 120, maxHeight: 60, backgroundSize: 'cover' }
    };

    const handleClick = (name, value) => {
        setState((st) => {
            const nst = { ...st, [name]: value };
            return nst;
        });
    };

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setState((st) => ({ ...st, [name]: value }));
    };

    const handleSubmit = async () => {
        const data = {
            PortalSettingId: state.Id,
            PortalSettingCallUs: state.CallUs,
            PortalSettingOpeningTime: state.OpeningTimes,
            PortalSettingEmailUs: state.EmailUs,
            PortalSettingTitle: state.Title,
            PortalHeaderBackgroundColour: state.HeaderBackgroundColorCode,
            PortalHeaderTextColour: state.HeaderTextColorCode,
            PortalMenuBarBackgroundColour: state.MenubarBackgroundColorCode,
            PortalMenuBarTextColour: state.MenubarTextColorCode,
            portalSettingsRecallJobTextColor: state.portalSettingsRecallJobTextColor,
            portalSettingsRecallJobBgColor: state.portalSettingsRecallJobBgColor,
            portalSettingsRepairTextColor: state.portalSettingsRepairTextColor,
            portalSettingsRepairBgColor: state.portalSettingsRepairBgColor,
            portalSettingsMOTTextColor: state.portalSettingsMOTTextColor,
            portalSettingsMOTBgColor: state.portalSettingsMOTBgColor,
            portalSettingsInspectionTextColor: state.portalSettingsInspectionTextColor,
            portalSettingsInspectionBgColor: state.portalSettingsInspectionBgColor,
            portalSettingsCustomerWaitingTextColor: state.portalSettingsCustomerWaitingTextColor,
            portalSettingsCustomerWaitingBgColor: state.portalSettingsCustomerWaitingBgColor,
            portalSettingsCollectionDeliverTextColor: state.portalSettingsCollectionDeliverTextColor,
            portalSettingsCollectionDeliverBgColor: state.portalSettingsCollectionDeliverBgColor,
            portalSettingsServiceTextColor: state.portalSettingsServiceTextColor,
            portalSettingsServiceBgColor: state.portalSettingsServiceBgColor,
            portalSettingsNightShiftTextColor: state.portalSettingsNightShiftTextColor,
            portalSettingsNightShiftBgColor: state.portalSettingsNightShiftBgColor,
            portalSettingsTachoTextColor: state.portalSettingsTachoTextColor,
            portalSettingsTachoBgColor: state.portalSettingsTachoBgColor,
            portalSettingsLoanVehicleBgColor: state.portalSettingsLoanVehicleBgColor,
            portalSettingsLoanVehicleTextColor: state.portalSettingsLoanVehicleTextColor,
            portalSettingsRecallJobText: state.portalSettingsRecallJobText,
            portalSettingsRepairText: state.portalSettingsRepairText,
            portalSettingsMOTText: state.portalSettingsMOTText,
            portalSettingsInspectionText: state.portalSettingsInspectionText,
            portalSettingsCustomerWaitingText: state.portalSettingsCustomerWaitingText,
            portalSettingsCollectionDeliverText: state.portalSettingsCollectionDeliverText,
            portalSettingsServiceText: state.portalSettingsServiceText,
            portalSettingsNightShiftText: state.portalSettingsNightShiftText,
            portalSettingsTachoText: state.portalSettingsTachoText,
            portalSettingsLoanVehicleText: state.portalSettingsLoanVehicleText,
            portalSettingsIsHolidayBgColor: state.portalSettingsIsHolidayBgColor,
            portalSettingsIsHolidayColor: state.portalSettingsIsHolidayColor,

            PortalSettingBannerImage: state.bannerImage,
            PortalSettingTechnicianDeclaration: state.portalSettingTechnicianDeclaration,
            PortalSettingQCMessage: state.Qual,
            PortalSettingDisplayTopNavCounters: state.navigationMenuActive,
            workflowStepOptionsAsButtonGroup: state.workflowStepOptionsAsButtonGroup,
            hideWorkAccomplishedAndFailureReasons: state.hideWorkAccomplishedAndFailureReasons,
            portalSettingSaveNewDoc: state.portalSettingSaveNewDoc,
            PortalSettingMainLogo: state.productLogo,
            PortalSettingBanner: state.bannerLogo,
            PortalSettingAdditionalLogo: state.labelLogo,
            PortalSettingDiagnosticCharges: state.Diag,
            portalSettingsTermsOfService: state.termsOfService,
            portalSettingGridRefreshTime: state.portalSettingGridRefreshTime,
            portalSettingTechnWriteupHeight: state.portalSettingTechnWriteupHeight,
            portalSettingDisplayPartStockStatus: state.portalSettingDisplayPartStockStatus,
            portalHighPriorityJobColour: state.portalHighPriorityJobColour,
            portalSettingGridActionLabel: state.portalSettingGridActionLabel || '',
            portalSettingGridWIPNoLabel: state.portalSettingGridWIPNoLabel || '',
            portalSettingGridVehicleRegLabel: state.portalSettingGridVehicleRegLabel || '',
            portalSettingGridModelLabel: state.portalSettingGridModelLabel || '',
            portalSettingGridCustomerNameLabel: state.portalSettingGridCustomerNameLabel || '',
            portalSettingGridDateDueInLabel: state.portalSettingGridDateDueInLabel || '',
            portalSettingGridDateDueOutLabel: state.portalSettingGridDateDueOutLabel || '',
            portalSettingGridReturnReasonLabel: state.portalSettingGridReturnReasonLabel || '',
            portalSettingGridBranchLabel: state.portalSettingGridBranchLabel || '',
            portalSettingGridFranchiseLabel: state.portalSettingGridFranchiseLabel || '',
            portalSettingGridJobDescriptionLabel: state.portalSettingGridJobDescriptionLabel || '',
            portalSettingGridAccountLabel: state.portalSettingGridAccountLabel || '',
            portalSettingGridCreatedByLabel: state.portalSettingGridCreatedByLabel || '',
            portalSettingGridAssignedDateLabel: state.portalSettingGridAssignedDateLabel || '',
            portalSettingGridTimeTakenLabel: state.portalSettingGridTimeTakenLabel || '',
            portalSettingGridStatusLabel: state.portalSettingGridStatusLabel || '',
            portalSettingGridAssignedDaysLabel: state.portalSettingGridAssignedDaysLabel || '',
            portalSettingGridChassisNumberLabel: state.portalSettingGridChassisNumberLabel || '',
            portalSettingGridOwningOperatorLabel: state.portalSettingGridOwningOperatorLabel || '',
            portalSettingGridJobAssignedUserLabel: state.portalSettingGridJobAssignedUserLabel || '',
            portalSettingUnassignedTechnicianJobWorkflowID: state.portalSettingUnassignedTechnicianJobWorkflowID || '',
            portalSettingGridCustomerWaitingLabel: state.portalSettingGridCustomerWaitingLabel || '',
            portalSettingGridCourtesyCarReqLabel: state.portalSettingGridCourtesyCarReqLabel || '',
            portalSettingGridWIPAgeLabel: state.portalSettingGridWIPAgeLabel || '',
            portalSettingGridIsFMOrWarrantyLabel: state.portalSettingGridIsFMOrWarrantyLabel || '',
            portalSettingGridIsBreakdownLabel: state.portalSettingGridIsBreakdownLabel || '',
            portalSettingGridIsNightShiftLabel: state.portalSettingGridIsNightShiftLabel || '',
            // portalSettingGridJobAssignedUserLabel: state.portalSettingGridJobAssignedUserLabel || '',
            portalSettingTimeOut: state.portalSettingTimeOut || '',
            portalSettingPasswordExpiryDuration: state.portalSettingPasswordExpiryDuration || null,

            portalSettingsPassowrdMinimumLength: state.portalSettingsPassowrdMinimumLength,
            portalSettingFMWarrantyWarningmsg: state.portalSettingFMWarrantyWarningmsg || '',
            portalSettingDisplayAssignedWorkflows: state.portalSettingDisplayAssignedWorkflows,
            portalSettingNightShiftWorkflowID: state.portalSettingNightShiftWorkflowID,
            portalSettingReturnReasonID: state.portalSettingReturnReasonID,
            portalSettingWorkflowNotification: state.portalSettingWorkflowNotification,
            // portalSettingReportingEnabled: state.portalSettingReportingEnabled
            portalSettingSpecialEquipmentEnabled: state.portalSettingSpecialEquipmentEnabled,
            showRegNumberInCustomerRatingBox: state.showRegNumberInCustomerRatingBox,

            canCustomerViewNotesButton: state.canCustomerViewNotesButton || false,
            canCustomerViewHistoryButton: state.canCustomerViewHistoryButton || false,
            canCustomerViewSaveButton: state.canCustomerViewSaveButton || false,
            canCustomerViewSaveAndCompleteButton: state.canCustomerViewSaveAndCompleteButton || false,
            canCustomerViewReturnButton: state.canCustomerViewReturnButton || false,
            canCustomerViewReturnReasonHistoryButton: state.canCustomerViewReturnReasonHistoryButton || false,
            canCustomerViewAllDocumentsButton: state.canCustomerViewAllDocumentsButton || false,
            canAuditorViewNotesButton: state.canAuditorViewNotesButton || false,
            canAuditorViewHistoryButton: state.canAuditorViewHistoryButton || false,
            canAuditorViewSaveButton: state.canAuditorViewSaveButton || false,
            canAuditorViewSaveAndCompleteButton: state.canAuditorViewSaveAndCompleteButton || false,
            canAuditorViewReturnButton: state.canAuditorViewReturnButton || false,
            canAuditorViewReturnReasonHistoryButton: state.canAuditorViewReturnReasonHistoryButton || false,
            canAuditorViewAllDocumentsButton: state.canAuditorViewAllDocumentsButton || false,
            portalSettingsShowTechWriteUpSaveBtn: state.portalSettingsShowTechWriteUpSaveBtn || false,
            portalSettingDisplaySubmitbutton: state.portalSettingDisplaySubmitbutton || false,
            portalSettingDisallowTechnicianSignatureOnSaveButton: state.portalSettingDisallowTechnicianSignatureOnSaveButton || false,
            portalSettingGridIsFMOrWarrantyLabel: state.portalSettingGridIsFMOrWarrantyLabel || '',
            portalSettingGridIsBreakdownLabel: state.portalSettingGridIsBreakdownLabel || '',
            portalSettingGridIsNightShiftLabel: state.portalSettingGridIsNightShiftLabel || '',
            portalSettingGridIsHighPriorityLabel: state.portalSettingGridIsHighPriorityLabel || '',
            portalSettingWriteupsInUpperCase: state.portalSettingWriteupsInUpperCase || false,
            canHideDocumentCreation: state.canHideDocumentCreation || false,
            canDeletePartRequests: state.canDeletePartRequests || false,
            portalSettingsRecallIsTcardColor: state.portalSettingsRecallIsTcardColor || false,
            portalSettingsRepairIsTcardColor: state.portalSettingsRepairIsTcardColor || false,
            portalSettingsMOTIsTcardColor: state.portalSettingsMOTIsTcardColor || false,
            portalSettingsInspectionIsTcardColor: state.portalSettingsInspectionIsTcardColor || false,
            portalSettingsCustomerWaitingIsTcardColor: state.portalSettingsCustomerWaitingIsTcardColor || false,
            portalSettingsCollectionDeliverIsTcardColor: state.portalSettingsCollectionDeliverIsTcardColor || false,
            portalSettingsServiceIsTcardColor: state.portalSettingsServiceIsTcardColor || false,
            portalSettingsNightShiftIsTcardColor: state.portalSettingsNightShiftIsTcardColor || false,
            portalSettingsTachoIsTcardColor: state.portalSettingsTachoIsTcardColor || false,
            portalSettingsLoanVehicleIsTcardColor: state.portalSettingsLoanVehicleIsTcardColor || false,
            vehicleStatusNotArrivedTxtColor: state.vehicleStatusNotArrivedTxtColor || '',
            vehicleStatusOnSiteTxtColor: state.vehicleStatusOnSiteTxtColor || '',
            vehicleStatusOffsiteTxtColor: state.vehicleStatusOffsiteTxtColor || '',
            vehicleStatusNotArrivedBgColor: state.vehicleStatusNotArrivedBgColor || '',
            vehicleStatusOnSiteBgColor: state.vehicleStatusOnSiteBgColor || '',
            vehicleStatusOffsiteBgColor: state.vehicleStatusOffsiteBgColor || ''
        };

        let res = await addPortalSettings(data);
        if (res.success) {
            const portalSettingsStr = AppStorage.getPortalSetting();
            if (portalSettingsStr) {
                // Parse the JSON string to get the object
                // Update the value of portalSettingsPasswordMinimumLength
                portalSettingsStr.portalSettingsPassowrdMinimumLength = +state.portalSettingsPassowrdMinimumLength;
                // Store the updated object back into localStorage
                AppStorage.setPortalSetting(portalSettingsStr);
            }
            showToast('Portal setting saved successfully');
            props.history.push('/');
        } else {
            showToast(res.message);
        }
    };

    useEffect(async () => {
        pullSettingsAndUpdateState();
        let result1 = await getWorkflows();
        setState((st) => ({
            ...st,
            workFlowList: result1.data.map((m) => ({ id: m.id, name: m.workflowName }))
        }));
    }, []);
    useEffect(async () => {
        if (state.portalSettingNightShiftWorkflowID) {
            let result1 = await getByWorkflowIdAndHeaderId(state.portalSettingNightShiftWorkflowID);
            setState((st) => ({
                ...st,
                returnReasonList: result1.data.returnReasons.map((q) => ({ id: q.returnReasonID, name: q.returnReasonDescription }))
            }));
        } else {
            setState((st) => ({
                ...st,
                returnReasonList: []
            }));
        }
    }, [state.portalSettingNightShiftWorkflowID]);

    const handleCkeditorstate = (name) => (event, editor) => {
        const data = editor.getData();
        setState((st) => ({ ...st, [name]: data }));
    };

    const handleCheckbox = (e, a) => {
        setState((st) => ({ ...st, [e.target.name]: a }));
    };

    const tabs = [
        ...(portalSettings.portalSettingeWIPEnabled
            ? [
                  {
                      label: 'eWIP',
                      body: (
                          <EwipModule
                              state={state}
                              handleClick={handleClick}
                              handleFieldChange={handleFieldChange}
                              handleCkeditorstate={handleCkeditorstate}
                              handleCheckbox={handleCheckbox}
                          />
                      )
                  }
              ]
            : []),
        // ...(portalSettings.portalSettingReportingEnabled
        //     ? [
        //           {
        //               label: 'Reporting',
        //               body: <></>
        //           }
        //       ]
        //     : null)
        ...(!portalSettings.portalSettingCommunicatorEnabled
            ? [
                  {
                      label: 'Communicator',
                      body: <CommunicatorModule state={state} OnColorSelect={OnColorSelect} />
                  }
              ]
            : [])
    ];

    const handleDoneICon = (name) => {
        setState((st) => ({ ...st, [name]: !st[name] }));
    };

    const InputCheckIcon = ({ name }) => {
        return (
            <InputAdornment position="end">
                <CheckCircleIcon onClick={() => handleDoneICon(name)} style={{ cursor: 'pointer', color: state[name] ? 'green' : 'grey' }} />
            </InputAdornment>
        );
    };

    return (
        <div className="setting-screen" style={{ margin: 10 }}>
            <BreadCrumbs crumbs={crumbs} />
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                    <FormLabel>Portal Title</FormLabel>
                    <TextBox inputLabel="Portal Title" placeholder="Portal Title" value={state.Title} onChange={handleFieldChange} name="Title" />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormLabel>Call Us</FormLabel>
                    <TextBox inputLabel="Call Us" placeholder="Number" value={state.CallUs} onChange={handleFieldChange} name="CallUs" />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormLabel>Opening Times</FormLabel>
                    <TextBox
                        inputLabel="Opening Times"
                        placeholder="Opening Times"
                        value={state.OpeningTimes}
                        onChange={handleFieldChange}
                        name="OpeningTimes"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormLabel>Email Us</FormLabel>
                    <TextBox inputLabel="Email us" placeholder="Email us" value={state.EmailUs} onChange={handleFieldChange} name="EmailUs" />
                </Grid>
            </Grid>
            <Grid item container spacing={2}>
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                    <Typography variant="h5" color="secondary">
                        Colors
                    </Typography>
                    <hr />
                </Grid>
            </Grid>

            <Grid container spacing={0} justify="space-around" style={{ textAlign: 'left' }}>
                <Grid container spacing={2} style={{ marginTop: '40px', marginLeft: '20px' }}>
                    <Grid container md={3} spacing={2} style={{ marginBottom: '15px' }}>
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    <div
                                        style={{
                                            backgroundColor: state.HeaderBackgroundColorCode,
                                            color: state.HeaderTextColorCode,
                                            padding: 3
                                        }}
                                    >
                                        <b>Header</b>
                                    </div>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    <b>Text / Background</b>
                                </FormLabel>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12} spacing={1} alignItems="center" style={{ marginTop: '-15px' }}>
                            <Grid item xs={6}></Grid>

                            {/* Color Picker for Text */}
                            <Grid container item xs={6}>
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="HeaderTextColorCode"
                                        id="HeaderTextColorCode"
                                        color={state.HeaderTextColorCode}
                                        onChange={(updatedColor) =>
                                            setState((state) => ({
                                                ...state,
                                                HeaderTextColorCode: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="HeaderBackgroundColorCode"
                                        id="HeaderBackgroundColorCode"
                                        color={state.HeaderBackgroundColorCode}
                                        onChange={(updatedColor) =>
                                            setState((state) => ({
                                                ...state,
                                                HeaderBackgroundColorCode: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container md={3} spacing={2} style={{ marginBottom: '15px' }}>
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    <div
                                        style={{
                                            backgroundColor: state.MenubarBackgroundColorCode,
                                            color: state.MenubarTextColorCode,
                                            padding: 3
                                        }}
                                    >
                                        <b>Menu bar</b>
                                    </div>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    <b>Text / Background</b>
                                </FormLabel>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12} spacing={1} alignItems="center" style={{ marginTop: '-15px' }}>
                            {/* Recall Job Text Field */}
                            <Grid item xs={6}></Grid>

                            {/* Color Picker for Text */}
                            <Grid container item xs={6}>
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="MenubarTextColorCode"
                                        id="MenubarTextColorCode"
                                        color={state.MenubarTextColorCode}
                                        onChange={(updatedColor) =>
                                            setState((state) => ({
                                                ...state,
                                                MenubarTextColorCode: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="HeaderBackgroundColorCode"
                                        id="HeaderBackgroundColorCode"
                                        color={state.MenubarBackgroundColorCode}
                                        onChange={(updatedColor) =>
                                            setState((state) => ({
                                                ...state,
                                                MenubarBackgroundColorCode: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container md={3} spacing={2} style={{ marginBottom: '15px' }}>
                        {/* Heading Row */}
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    {' '}
                                    <div
                                        style={{
                                            backgroundColor: state.portalSettingsRecallJobBgColor,
                                            color: state.portalSettingsRecallJobTextColor,
                                            padding: 3
                                        }}
                                    >
                                        <b>Recall Job</b>
                                    </div>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    <b>Text / Background</b>
                                </FormLabel>
                            </Grid>
                        </Grid>

                        <Grid container item xs={12} spacing={1} alignItems="center" style={{ marginTop: '-15px' }}>
                            {/* Recall Job Text Field */}
                            <Grid item xs={6}>
                                <TextBox
                                    value={state.portalSettingsRecallJobText}
                                    onChange={handleFieldChange}
                                    name="portalSettingsRecallJobText"
                                    style={{
                                        minWidth: '40px',
                                        height: '20px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        whiteSpace: 'nowrap'
                                    }}
                                    InputProps={{
                                        endAdornment: <InputCheckIcon name="portalSettingsRecallIsTcardColor" />
                                    }}
                                />
                            </Grid>

                            {/* Color Picker for Text */}
                            <Grid container item xs={6}>
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsRecallJobTextColor"
                                        id="portalSettingsRecallJobTextColor"
                                        color={state.portalSettingsRecallJobTextColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsRecallJobTextColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsRecallJobBgColor"
                                        id="portalSettingsRecallJobBgColor"
                                        color={state.portalSettingsRecallJobBgColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsRecallJobBgColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>
                            </Grid>

                            {/* Preview Box */}
                        </Grid>
                    </Grid>

                    {/* Repair Text */}
                    <Grid container md={3} spacing={2} style={{ marginBottom: '15px' }}>
                        {/* Heading Row */}
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    {' '}
                                    <div
                                        style={{
                                            backgroundColor: state.portalSettingsRepairBgColor,
                                            color: state.portalSettingsRepairTextColor,
                                            padding: 3
                                        }}
                                    >
                                        <b>Repair</b>
                                    </div>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    <b>Text / Background</b>
                                </FormLabel>
                            </Grid>
                        </Grid>

                        {/* Data Row */}
                        <Grid container item xs={12} spacing={1} alignItems="center" style={{ marginTop: '-15px' }}>
                            {/* Recall Job Text Field */}
                            {/* Preview Box */}
                            <Grid item xs={6}>
                                <TextBox
                                    value={state.portalSettingsRepairText}
                                    onChange={handleFieldChange}
                                    name="portalSettingsRepairText"
                                    style={{
                                        minWidth: '40px',
                                        height: '20px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        whiteSpace: 'nowrap'
                                    }}
                                    InputProps={{
                                        endAdornment: <InputCheckIcon name="portalSettingsRepairIsTcardColor" />
                                    }}
                                />
                            </Grid>

                            {/* Color Picker for Text */}
                            <Grid container item xs={6}>
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsRepairTextColor"
                                        id="portalSettingsRepairTextColor"
                                        color={state.portalSettingsRepairTextColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsRepairTextColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>
                                {/* Color Picker for Background */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsRepairBgColor"
                                        id="portalSettingsRepairBgColor"
                                        color={state.portalSettingsRepairBgColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsRepairBgColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* MOT Section */}
                    <Grid container md={3} spacing={2} style={{ marginBottom: '15px' }}>
                        {/* Heading Row */}
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    {' '}
                                    <div
                                        style={{
                                            backgroundColor: state.portalSettingsMOTBgColor,
                                            color: state.portalSettingsMOTTextColor,
                                            padding: 3
                                        }}
                                    >
                                        <b>MOT</b>
                                    </div>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    <b>Text / Background</b>
                                </FormLabel>
                            </Grid>
                        </Grid>

                        {/* Data Row */}
                        <Grid container item xs={12} spacing={1} alignItems="center" style={{ marginTop: '-15px' }}>
                            {/* MOT Text Field */}
                            <Grid item xs={6}>
                                <TextBox
                                    value={state.portalSettingsMOTText}
                                    onChange={handleFieldChange}
                                    name="portalSettingsMOTText"
                                    style={{
                                        minWidth: '40px',
                                        height: '20px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        whiteSpace: 'nowrap'
                                    }}
                                    InputProps={{
                                        endAdornment: <InputCheckIcon name="portalSettingsMOTIsTcardColor" />
                                    }}
                                />
                            </Grid>

                            {/* Color Picker for Text */}
                            <Grid container item xs={6}>
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsMOTTextColor"
                                        id="portalSettingsMOTTextColor"
                                        color={state.portalSettingsMOTTextColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsMOTTextColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>

                                {/* Color Picker for Background */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsMOTBgColor"
                                        id="portalSettingsMOTBgColor"
                                        color={state.portalSettingsMOTBgColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsMOTBgColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>
                            </Grid>
                            {/* Preview Box */}
                        </Grid>
                    </Grid>

                    {/* Inspection Text */}
                    <Grid container md={3} spacing={2} style={{ marginBottom: '15px' }}>
                        {/* Heading Row */}
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    {' '}
                                    <div
                                        style={{
                                            backgroundColor: state.portalSettingsInspectionBgColor,
                                            color: state.portalSettingsInspectionTextColor,
                                            padding: 3
                                        }}
                                    >
                                        <b>Inspection</b>
                                    </div>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    <b>Text / Background</b>
                                </FormLabel>
                            </Grid>
                        </Grid>

                        {/* Data Row */}
                        <Grid container item xs={12} spacing={1} alignItems="center" style={{ marginTop: '-15px' }}>
                            {/* Preview Box */}
                            <Grid item xs={6}>
                                <TextBox
                                    value={state.portalSettingsInspectionText}
                                    onChange={handleFieldChange}
                                    name="portalSettingsInspectionText"
                                    style={{
                                        minWidth: '40px',
                                        height: '20px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        whiteSpace: 'nowrap'
                                    }}
                                    InputProps={{
                                        endAdornment: <InputCheckIcon name="portalSettingsInspectionIsTcardColor" />
                                    }}
                                />
                            </Grid>
                            <Grid container item xs={6}>
                                {/* Color Picker for Text */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsInspectionTextColor"
                                        id="portalSettingsInspectionTextColor"
                                        color={state.portalSettingsInspectionTextColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsInspectionTextColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>

                                {/* Color Picker for Background */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsInspectionBgColor"
                                        id="portalSettingsInspectionBgColor"
                                        color={state.portalSettingsInspectionBgColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsInspectionBgColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* Customer Waiting Text */}
                    <Grid container md={3} spacing={2} style={{ marginBottom: '15px' }}>
                        {/* Heading Row */}
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    {' '}
                                    <div
                                        style={{
                                            backgroundColor: state.portalSettingsCustomerWaitingBgColor,
                                            color: state.portalSettingsCustomerWaitingTextColor,
                                            padding: 3
                                        }}
                                    >
                                        <b>Customer Waiting</b>
                                    </div>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    <b>Text / Background</b>
                                </FormLabel>
                            </Grid>
                        </Grid>

                        {/* Data Row */}
                        <Grid container item xs={12} spacing={1} alignItems="center" style={{ marginTop: '-15px' }}>
                            {/* Customer Waiting Text Field */}
                            {/* Preview Box */}
                            <Grid item xs={6}>
                                <TextBox
                                    value={state.portalSettingsCustomerWaitingText}
                                    onChange={handleFieldChange}
                                    name="portalSettingsCustomerWaitingText"
                                    style={{
                                        minWidth: '40px',
                                        height: '20px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        whiteSpace: 'nowrap'
                                    }}
                                    InputProps={{
                                        endAdornment: <InputCheckIcon name="portalSettingsCustomerWaitingIsTcardColor" />
                                    }}
                                />
                            </Grid>
                            <Grid container item xs={6}>
                                {/* Color Picker for Text */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsCustomerWaitingTextColor"
                                        id="portalSettingsCustomerWaitingTextColor"
                                        color={state.portalSettingsCustomerWaitingTextColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsCustomerWaitingTextColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>

                                {/* Color Picker for Background */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsCustomerWaitingBgColor"
                                        id="portalSettingsCustomerWaitingBgColor"
                                        color={state.portalSettingsCustomerWaitingBgColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsCustomerWaitingBgColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* Collection Deliver Text */}
                    <Grid container md={3} spacing={2} style={{ marginBottom: '15px' }}>
                        {/* Heading Row */}
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    {' '}
                                    <div
                                        style={{
                                            backgroundColor: state.portalSettingsCollectionDeliverBgColor,
                                            color: state.portalSettingsCollectionDeliverTextColor,
                                            padding: 3
                                        }}
                                    >
                                        <b>Collection Deliver</b>
                                    </div>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    <b>Text / Background</b>
                                </FormLabel>
                            </Grid>
                        </Grid>

                        {/* Data Row */}
                        <Grid container item xs={12} spacing={1} alignItems="center" style={{ marginTop: '-15px' }}>
                            {/* Collection Deliver Text Field */}
                            {/* Preview Box */}
                            <Grid item xs={6}>
                                <TextBox
                                    value={state.portalSettingsCollectionDeliverText}
                                    onChange={handleFieldChange}
                                    name="portalSettingsCollectionDeliverText"
                                    style={{
                                        minWidth: '40px',
                                        height: '20px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        whiteSpace: 'nowrap'
                                    }}
                                    InputProps={{
                                        endAdornment: <InputCheckIcon name="portalSettingsCollectionDeliverIsTcardColor" />
                                    }}
                                />
                            </Grid>
                            <Grid container item xs={6}>
                                {/* Color Picker for Text */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsCollectionDeliverTextColor"
                                        id="portalSettingsCollectionDeliverTextColor"
                                        color={state.portalSettingsCollectionDeliverTextColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsCollectionDeliverTextColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>

                                {/* Color Picker for Background */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsCollectionDeliverBgColor"
                                        id="portalSettingsCollectionDeliverBgColor"
                                        color={state.portalSettingsCollectionDeliverBgColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsCollectionDeliverBgColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* Service Text */}
                    <Grid container md={3} spacing={2} style={{ marginBottom: '15px' }}>
                        {/* Heading Row */}
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    {' '}
                                    <div
                                        style={{
                                            backgroundColor: state.portalSettingsServiceBgColor,
                                            color: state.portalSettingsServiceTextColor,
                                            padding: 3
                                        }}
                                    >
                                        <b>Service</b>
                                    </div>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    <b>Text / Background</b>
                                </FormLabel>
                            </Grid>
                        </Grid>

                        {/* Data Row */}
                        <Grid container item xs={12} spacing={1} alignItems="center" style={{ marginTop: '-15px' }}>
                            {/* Service Text Field */}
                            <Grid item xs={6}>
                                <TextBox
                                    value={state.portalSettingsServiceText}
                                    onChange={handleFieldChange}
                                    name="portalSettingsServiceText"
                                    style={{
                                        minWidth: '40px',
                                        height: '20px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        whiteSpace: 'nowrap'
                                    }}
                                    InputProps={{
                                        endAdornment: <InputCheckIcon name="portalSettingsServiceIsTcardColor" />
                                    }}
                                />
                            </Grid>
                            <Grid container item xs={6}>
                                {/* Color Picker for Text */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsServiceTextColor"
                                        id="portalSettingsServiceTextColor"
                                        color={state.portalSettingsServiceTextColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsServiceTextColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>

                                {/* Color Picker for Background */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsServiceBgColor"
                                        id="portalSettingsServiceBgColor"
                                        color={state.portalSettingsServiceBgColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsServiceBgColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* Night Shift Text */}
                    <Grid container md={3} spacing={2} style={{ marginBottom: '15px' }}>
                        {/* Heading Row */}
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    {' '}
                                    <div
                                        style={{
                                            backgroundColor: state.portalSettingsNightShiftBgColor,
                                            color: state.portalSettingsNightShiftTextColor,
                                            padding: 3
                                        }}
                                    >
                                        <b>Night Shift</b>
                                    </div>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    <b>Text / Background</b>
                                </FormLabel>
                            </Grid>
                        </Grid>

                        {/* Data Row */}
                        <Grid container item xs={12} spacing={1} alignItems="center" style={{ marginTop: '-15px' }}>
                            {/* Preview Box */}
                            <Grid item xs={6}>
                                <TextBox
                                    value={state.portalSettingsNightShiftText}
                                    onChange={handleFieldChange}
                                    name="portalSettingsNightShiftText"
                                    style={{
                                        minWidth: '40px',
                                        height: '20px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        whiteSpace: 'nowrap'
                                    }}
                                    InputProps={{
                                        endAdornment: <InputCheckIcon name="portalSettingsNightShiftIsTcardColor" />
                                    }}
                                />
                            </Grid>
                            <Grid container item xs={6}>
                                {/* Color Picker for Text */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsNightShiftTextColor"
                                        id="portalSettingsNightShiftTextColor"
                                        color={state.portalSettingsNightShiftTextColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsNightShiftTextColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>

                                {/* Color Picker for Background */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsNightShiftBgColor"
                                        id="portalSettingsNightShiftBgColor"
                                        color={state.portalSettingsNightShiftBgColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsNightShiftBgColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* Tacho Text */}
                    <Grid container md={3} spacing={2} style={{ marginBottom: '15px' }}>
                        {/* Heading Row */}
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    {' '}
                                    <div
                                        style={{
                                            backgroundColor: state.portalSettingsTachoBgColor,
                                            color: state.portalSettingsTachoTextColor,
                                            padding: 3
                                        }}
                                    >
                                        <b>Tacho</b>
                                    </div>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    <b>Text / Background</b>
                                </FormLabel>
                            </Grid>
                        </Grid>

                        {/* Data Row */}
                        <Grid container item xs={12} spacing={1} alignItems="center" style={{ marginTop: '-15px' }}>
                            {/* Tacho Text Field */}
                            {/* Preview Box */}
                            <Grid item xs={6}>
                                <TextBox
                                    value={state.portalSettingsTachoText}
                                    onChange={handleFieldChange}
                                    name="portalSettingsTachoText"
                                    style={{
                                        minWidth: '40px',
                                        height: '20px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        whiteSpace: 'nowrap'
                                    }}
                                    InputProps={{
                                        endAdornment: <InputCheckIcon name="portalSettingsTachoIsTcardColor" />
                                    }}
                                />
                            </Grid>
                            <Grid container item xs={6}>
                                {/* Color Picker for Text */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsTachoTextColor"
                                        id="portalSettingsTachoTextColor"
                                        color={state.portalSettingsTachoTextColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsTachoTextColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>

                                {/* Color Picker for Background */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsTachoBgColor"
                                        id="portalSettingsTachoBgColor"
                                        color={state.portalSettingsTachoBgColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsTachoBgColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* Loan Vehicle Text */}
                    <Grid container md={3} spacing={2} style={{ marginBottom: '15px' }}>
                        {/* Heading Row */}
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    <div
                                        style={{
                                            backgroundColor: state.portalSettingsLoanVehicleBgColor,
                                            color: state.portalSettingsLoanVehicleTextColor,
                                            padding: 3
                                        }}
                                    >
                                        <b>Loan Vehicle</b>
                                    </div>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={6}>
                                <FormLabel component="legend">
                                    <b>Text / Background</b>
                                </FormLabel>
                            </Grid>
                        </Grid>

                        {/* Data Row */}
                        <Grid container item xs={12} spacing={1} alignItems="center" style={{ marginTop: '-15px' }}>
                            {/* Loan Vehicle Text Field */}
                            <Grid item xs={6}>
                                <TextBox
                                    value={state.portalSettingsLoanVehicleText}
                                    onChange={handleFieldChange}
                                    name="portalSettingsLoanVehicleText"
                                    style={{
                                        minWidth: '40px',
                                        height: '20px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        whiteSpace: 'nowrap'
                                    }}
                                    InputProps={{
                                        endAdornment: <InputCheckIcon name="portalSettingsLoanVehicleIsTcardColor" />
                                    }}
                                />
                            </Grid>
                            <Grid container item xs={6}>
                                {/* Color Picker for Text */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsLoanVehicleTextColor"
                                        id="portalSettingsLoanVehicleTextColor"
                                        color={state.portalSettingsLoanVehicleTextColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsLoanVehicleTextColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>

                                {/* Color Picker for Background */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsLoanVehicleBgColor"
                                        id="portalSettingsLoanVehicleBgColor"
                                        color={state.portalSettingsLoanVehicleBgColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsLoanVehicleBgColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>
                            </Grid>
                            {/* Preview Box */}
                        </Grid>
                    </Grid>
                    <Grid container md={3} spacing={2} style={{ marginBottom: '15px' }}>
                        {/* Heading Row */}
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={4}>
                                <FormLabel component="legend">
                                    {' '}
                                    <div
                                        style={{
                                            backgroundColor: state.portalSettingsIsHolidayBgColor,
                                            color: state.portalSettingsIsHolidayColor,
                                            minWidth: '40px',
                                            height: '20px',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '3px',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        <b>Holiday</b>
                                    </div>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={8}>
                                <FormLabel component="legend">
                                    <b>Color Picker / Background</b>
                                </FormLabel>
                            </Grid>
                        </Grid>

                        {/* Data Row */}
                        <Grid container item xs={12} spacing={1} alignItems="center" style={{ marginTop: '-15px' }}>
                            {/* Preview Box */}
                            <Grid item xs={6}>
                                <b></b>
                            </Grid>
                            <Grid container item xs={6}>
                                {/* Color Picker for Text */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsIsHolidayColor"
                                        id="portalSettingsIsHolidayColor"
                                        color={state.portalSettingsIsHolidayColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsIsHolidayColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>

                                {/* Color Picker for Background */}
                                <Grid item xs={3}>
                                    <ColorPicker
                                        height="15px"
                                        width="20px"
                                        name="portalSettingsIsHolidayBgColor"
                                        id="portalSettingsIsHolidayBgColor"
                                        color={state.portalSettingsIsHolidayBgColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                portalSettingsIsHolidayBgColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <>
                <Grid container spacing={2} style={{ textAlign: 'left', paddingTop: '15px' }}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Typography variant="h5" color="secondary">
                            Vehicle Status
                        </Typography>
                        <hr />
                    </Grid>

                    <Grid container spacing={1} item xs={12} md={6} lg={2} style={{ textAlign: 'left' }}>
                        <Grid item xs={6} container spacing={2}>
                            <Grid item xs={12}>
                                <FormLabel component="legend">
                                    <b>Not Arrived</b>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        display: 'inline-block',
                                        px: 2,
                                        py: 1,
                                        borderRadius: '4px',
                                        backgroundColor: state.vehicleStatusNotArrivedBgColor,
                                        color: state.vehicleStatusNotArrivedTxtColor,
                                        fontWeight: 'bold',
                                        fontSize: '0.875rem'
                                    }}
                                >
                                    Not Arrived
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid item xs={6} container spacing={2}>
                            <Grid item xs={12}>
                                <FormLabel component="legend">
                                    <b>Text/Background</b>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={12}>
                                <Box display="flex" gap={2}>
                                    <ColorPicker
                                        height="30px"
                                        width="30px"
                                        name="vehicleStatusNotArrivedTxtColor"
                                        id="vehicleStatusNotArrivedTxtColor"
                                        color={state.vehicleStatusNotArrivedTxtColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                vehicleStatusNotArrivedTxtColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                    <ColorPicker
                                        height="30px"
                                        width="30px"
                                        name="vehicleStatusNotArrivedBgColor"
                                        id="vehicleStatusNotArrivedBgColor"
                                        color={state.vehicleStatusNotArrivedBgColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                vehicleStatusNotArrivedBgColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1} item xs={12} md={6} lg={2} style={{ textAlign: 'left' }}>
                        <Grid item xs={6} container spacing={2}>
                            <Grid item xs={12}>
                                <FormLabel component="legend">
                                    <b>On Site</b>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        display: 'inline-block',
                                        px: 2,
                                        py: 1,
                                        borderRadius: '4px',
                                        backgroundColor: state.vehicleStatusOnSiteBgColor,
                                        color: state.vehicleStatusOnSiteTxtColor,
                                        fontWeight: 'bold',
                                        fontSize: '0.875rem'
                                    }}
                                >
                                    On Site
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid item xs={6} container spacing={2}>
                            <Grid item xs={12}>
                                <FormLabel component="legend">
                                    <b>Text/Background</b>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={12}>
                                <Box display="flex" gap={2}>
                                    <ColorPicker
                                        height="30px"
                                        width="30px"
                                        name="vehicleStatusOnSiteTxtColor"
                                        id="vehicleStatusOnSiteTxtColor"
                                        color={state.vehicleStatusOnSiteTxtColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                vehicleStatusOnSiteTxtColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                    <ColorPicker
                                        height="30px"
                                        width="30px"
                                        name="vehicleStatusOnSiteBgColor"
                                        id="vehicleStatusOnSiteBgColor"
                                        color={state.vehicleStatusOnSiteBgColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                vehicleStatusOnSiteBgColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container spacing={1} item xs={12} md={6} lg={2} style={{ textAlign: 'left' }}>
                        <Grid item xs={6} container spacing={2}>
                            <Grid item xs={12}>
                                <FormLabel component="legend">
                                    <b>Off Site</b>
                                </FormLabel>
                            </Grid>

                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        display: 'inline-block',
                                        px: 2,
                                        py: 1,
                                        borderRadius: '4px',
                                        backgroundColor: state.vehicleStatusOffsiteBgColor,
                                        color: state.vehicleStatusOffsiteTxtColor,
                                        fontWeight: 'bold',
                                        fontSize: '0.875rem'
                                    }}
                                >
                                    Off Site
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid item xs={6} container spacing={2}>
                            <Grid item xs={12}>
                                <FormLabel component="legend">
                                    <b>Text/Background</b>
                                </FormLabel>
                            </Grid>
                            <Grid item xs={12}>
                                <Box display="flex" gap={2}>
                                    <ColorPicker
                                        height="30px"
                                        width="30px"
                                        name="vehicleStatusOffsiteTxtColor"
                                        id="vehicleStatusOffsiteTxtColor"
                                        color={state.vehicleStatusOffsiteTxtColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                vehicleStatusOffsiteTxtColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                    <ColorPicker
                                        height="30px"
                                        width="30px"
                                        name="vehicleStatusOffsiteBgColor"
                                        id="vehicleStatusOffsiteBgColor"
                                        color={state.vehicleStatusOffsiteBgColor}
                                        onChange={(updatedColor) =>
                                            setState((prev) => ({
                                                ...prev,
                                                vehicleStatusOffsiteBgColor: updatedColor.hex
                                            }))
                                        }
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </>
            <Grid container spacing={2} item xs={12} sm={12} style={{ textAlign: 'left', paddingTop: '15px' }}>
                <Grid item xs={12} md={12} lg={12}>
                    <Typography variant="h5" color="secondary">
                        Logos
                    </Typography>
                    <hr />
                </Grid>
                <Grid item xs={12} lg={3} sm={3} style={{ textAlign: 'left' }}>
                    <InputLabel shrink>Product Logo</InputLabel>
                    {state.productLogo ? (
                        <SecondaryButton onClick={clearImage('productLogo')}>Remove Logo</SecondaryButton>
                    ) : (
                        <input type="file" name="productLogo" onChange={handleImage('productLogo')} accept="image/*" />
                    )}
                </Grid>
                <Grid item xs={12} sm={3} lg={3} style={modelgridStyle.formatterImageContainer}>
                    <InputLabel shrink>{'\u{2800}'}</InputLabel>
                    {state.productLogo ? (
                        <img
                            src={state.productLogo?.includes('base64') ? state.productLogo : 'data:image/png;base64,' + state.productLogo}
                            alt={'logo'}
                            style={modelgridStyle.formatterImage}
                        />
                    ) : (
                        <p> Using default logo</p>
                    )}
                </Grid>
                <Grid item xs={12} lg={3} sm={3} style={{ textAlign: 'left' }}>
                    <InputLabel shrink style={{ paddingRight: '60px' }}>
                        Banner Image
                    </InputLabel>
                    {state.bannerLogo ? (
                        <SecondaryButton onClick={clearImage('bannerLogo')}>Remove Logo</SecondaryButton>
                    ) : (
                        <input type="file" name="bannerLogo" onChange={handleImage('bannerLogo')} accept="image/*" />
                    )}
                </Grid>
                <Grid item xs={12} sm={3} lg={3} style={modelgridStyle.formatterImageContainer}>
                    <InputLabel shrink>{'\u{2800}'}</InputLabel>
                    {state.bannerLogo ? (
                        <img
                            src={state.bannerLogo?.includes('base64') ? state.bannerLogo : 'data:image/png;base64,' + state.bannerLogo}
                            alt={'logo'}
                            style={modelgridStyle.formatterImage}
                        />
                    ) : (
                        <p> Using default image</p>
                    )}
                </Grid>
            </Grid>
            <Grid container item xs={12} sm={12}>
                <Grid item xs={12} md={12} lg={12} style={{ top: 0, textAlign: 'left' }}>
                    <Typography variant="h5" color="secondary">
                        Settings
                    </Typography>
                    <hr />
                </Grid>
                <Grid container style={{ textAlign: 'left' }} spacing={2}>
                    {/* <Grid xs={12} sm={6} md={3} container item>
                        <Grid item xs={12} style={{ marginBottom: '5px' }}>
                            <FormLabel>Display Top Navigation Counter?</FormLabel>
                        </Grid>
                        <YesNoButton
                            state={state.navigationMenuActive}
                            name="navigationMenuActive"
                            onYesClick={() => handleClick('navigationMenuActive', true)}
                            onNoClick={() => handleClick('navigationMenuActive', false)}
                        />
                    </Grid> */}
                    <Grid xs={12} sm={6} md={3} container item>
                        <Grid item xs={12}>
                            <InputLabel style={{ marginBottom: 7 }}>Session Timeout In Minutes</InputLabel>
                            <TextBox
                                inputLabel="Session Timeout In Minutes"
                                placeholder="Minutes"
                                value={state.portalSettingTimeOut}
                                onChange={handleFieldChange}
                                name="portalSettingTimeOut"
                            />
                        </Grid>
                    </Grid>
                    <Grid xs={12} sm={6} md={3} container item>
                        <Grid item xs={12}>
                            <InputLabel style={{ marginBottom: 7 }}>Password Expiry Duration In Days</InputLabel>
                            <TextBox
                                inputLabel="Session Timeout In Minutes"
                                placeholder="Days"
                                value={state.portalSettingPasswordExpiryDuration}
                                onChange={handleFieldChange}
                                name="portalSettingPasswordExpiryDuration"
                            />
                        </Grid>
                    </Grid>
                    <Grid xs={12} sm={6} md={3} container item>
                        <Grid item xs={12}>
                            <InputLabel style={{ marginBottom: 7 }}>Passowrd Minimum Length</InputLabel>
                            <TextBox
                                inputLabel="Passowrd Minimum Length"
                                placeholder="Days"
                                value={state.portalSettingsPassowrdMinimumLength}
                                onChange={handleFieldChange}
                                name="portalSettingsPassowrdMinimumLength"
                            />
                        </Grid>
                    </Grid>

                    {/* <Grid xs={12} sm={6} md={3} container item>
                        <Grid item xs={12}>
                            <InputLabel style={{ marginBottom: 7 }}>Display Assigned Workflows</InputLabel>
                            <TextBox
                                inputLabel="Passowrd Minimum Length"
                                placeholder=""
                                value={state.portalSettingDisplayAssignedWorkflows}
                                onChange={handleFieldChange}
                                name="portalSettingDisplayAssignedWorkflows"
                            />
                        </Grid>
                    </Grid>
                    <Grid xs={12} sm={6} md={3} container item>
                        <Grid item xs={12}>
                            <InputLabel style={{ marginBottom: 7 }}>NightShift Workflow ID</InputLabel>
                            <TextBox
                                inputLabel="Passowrd Minimum Length"
                                placeholder=""
                                value={state.portalSettingNightShiftWorkflowID}
                                onChange={handleFieldChange}
                                name="portalSettingNightShiftWorkflowID"
                            />
                        </Grid>
                    </Grid>
                    <Grid xs={12} sm={6} md={3} container item>
                        <Grid item xs={12}>
                            <InputLabel style={{ marginBottom: 7 }}>Return Reason ID</InputLabel>
                            <TextBox
                                inputLabel="Passowrd Minimum Length"
                                placeholder=""
                                value={state.portalSettingReturnReasonID}
                                onChange={handleFieldChange}
                                name="portalSettingReturnReasonID"
                            />
                        </Grid>
                    </Grid> */}
                </Grid>
            </Grid>
            <TabView tabList={tabs} id="testing_tabs" tabLableSize="1.2rem" tabLableWeight="700" />
            <Grid item xs={12} container spacing={2} style={{ marginTop: '10px' }}>
                <Grid item xs={6} className="submit_btn" style={{ textAlign: 'center' }}>
                    <SecondaryButton fullWidth onClick={handleSubmit}>
                        Save
                    </SecondaryButton>
                </Grid>
                <Grid item xs={6} className="submit_btn" style={{ textAlign: 'center' }}>
                    <SecondaryButton
                        fullWidth
                        onClick={() => {
                            props.history.push('/');
                        }}
                    >
                        Cancel
                    </SecondaryButton>
                </Grid>
            </Grid>
        </div>
    );
};

export default Settings;
